
import React from 'react';
import { Tabs, TabsList, TabsTrigger } from '@/components/ui/tabs';

interface BillingFrequencyTabsProps {
  availableIntervals: string[];
  selectedInterval: string;
  onIntervalChange: (interval: string) => void;
}

const BillingFrequencyTabs = ({ 
  availableIntervals, 
  selectedInterval, 
  onIntervalChange 
}: BillingFrequencyTabsProps) => {
  // Helper function to get interval display name
  const getIntervalDisplayName = (intervalKey: string) => {
    const [interval, count] = intervalKey.split('-');
    const intervalCount = parseInt(count);
    
    if (intervalCount === 1) {
      switch (interval) {
        case 'month': return 'Monthly';
        case 'year': return 'Yearly';
        case 'week': return 'Weekly';
        case 'day': return 'Daily';
        default: return interval.charAt(0).toUpperCase() + interval.slice(1);
      }
    } else {
      const pluralInterval = interval === 'month' ? 'months' : 
                           interval === 'year' ? 'years' :
                           interval === 'week' ? 'weeks' :
                           interval === 'day' ? 'days' : interval + 's';
      return `Every ${intervalCount} ${pluralInterval}`;
    }
  };

  if (availableIntervals.length === 0) {
    return null;
  }

  return (
    <Tabs value={selectedInterval} onValueChange={onIntervalChange} className="mb-12">
      <div className="flex justify-center mb-8">
        <TabsList className="h-12 p-1 bg-white shadow-lg rounded-xl border border-gray-200">
          {availableIntervals.map((intervalKey) => (
            <TabsTrigger 
              key={intervalKey} 
              value={intervalKey}
              className="px-6 py-2 text-sm font-medium rounded-lg transition-all text-gray-600 hover:text-gray-800 data-[state=active]:text-white data-[state=active]:bg-slate-700 data-[state=active]:shadow-md hover:data-[state=active]:bg-slate-600"
            >
              {getIntervalDisplayName(intervalKey)}
            </TabsTrigger>
          ))}
        </TabsList>
      </div>
    </Tabs>
  );
};

export default BillingFrequencyTabs;
